import React, { createContext, useState } from "react";

export const NavigationContext = createContext({
  navState: { title: null, bgColor: null, showTitle: false },
  navStateChangeHandler: (_title, _bgColor, _showTitle) => {},
});

const NavigationContextProvider = (props) => {
  const [navState, setNavState] = useState({
    title: null,
    bgColor: null,
    showTitle: true,
  });

  const navStateChangeHandler = (title, bgColor, showTitle) => {
    setNavState({ title, bgColor, showTitle });
  };

  return (
    <NavigationContext.Provider
      value={{
        navState,
        navStateChangeHandler,
      }}
    >
      {props.children}
    </NavigationContext.Provider>
  );
};

export default NavigationContextProvider;
